export const setSearchScope = (scope) => {
    if ( localStorage.getItem('searchScope') !== scope) {
        // -- Came from somewhere else; clear searchterms.
        let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
        jsonData = {
            ...jsonData,
            [scope] : {}
        }
        localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
    }

    localStorage.setItem('searchScope', scope);
}



// WEBPACK FOOTER //
// ./src/helpers/index.js